import { ADMIN, MANAGER } from "@/router/roles";

const validatePrivilege = auth => {
  if (auth && auth.privilege) {
    let priv = auth.privilege.split(",");
    if (priv.length) {
      return priv.some(p => [ADMIN, MANAGER].some(r => r === p));
    }
  }
  return false;
};

const allowedForRole = (routes, path, auth) => {
  if (routes.length && path && auth && auth.privilege) {
    let priv = auth.privilege.split(",");
    let item = routes.find(r => r.path === path);

    if (item) {
      let r = item.meta.roles;
      if (r.length === 0) {
        return true;
      } else {
        return r.some(m => priv.some(p => p === m));
      }
    }
  }
  return false;
};

const isAdmin = auth => {
  if (auth && auth.privilege) {
    let priv = auth.privilege.split(",");
    if (priv.length) {
      return priv.some(p => p === ADMIN);
    }
  }
  return false;
};

export { validatePrivilege, allowedForRole, isAdmin };
